import { withInstall } from '@vuemap/vue-amap-util'
import InfoWindow from './InfoWindow.vue'

export const ElAmapInfoWindow = withInstall(InfoWindow)
export default ElAmapInfoWindow
